import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LogoutComponent } from './hbo/logout/logout.component';
import { HboComponent } from './hbo/hbo.component';

const routes: Routes = [

	{
		path:'',
		component: HboComponent
	},
		{
		path:'logout',
		component: LogoutComponent
	},






];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
